import React, { createContext } from "react";

// "wm-*" are the Workplace Manager specific variants available only there
export type DesignName = "primary" | "marketing" | "wm-original" | "wm-compact";

export interface IDesignContext {
   name: DesignName
}
export const DesignContext = createContext<IDesignContext>({
   name: "marketing"
});

export interface IDesignContextProviderProps extends React.HTMLAttributes<HTMLDivElement> {
   name: DesignName
}

export const DesignContextProvider: React.FC<IDesignContextProviderProps> = function ({ children, name, ...rest }) {
   return (<DesignContext.Provider value={{
      name
   }}>
      <div data-design={name} {...rest}>{children}</div>
   </DesignContext.Provider>);
}